import { useQuery } from 'react-query';
import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// import required modules
import { Pagination, Navigation, Autoplay } from "swiper";
const Reviews = () => {

    const { isLoading, error, data: reviews } = useQuery('review', () =>
        fetch('https://fierce-sands-20967.herokuapp.com/reviews').then(res =>
            res.json()
        )
    )

    // const getratings = number => {
    //     const ratings = [];
    //     for (let i = 0; i < number; i++) {
    //         ratings.push(<input type="radio" name="rating-2" class="mask mask-star-2 bg-blue-400" />)

    //     }
    //     return ratings;
    // }

    // const gettingRatings = getratings(5)
    // console.log(reviews);
    return (
        // <div>

        // </div>
        <>
            <section className="team_container">
                <div className="team_slider my-10 py-5 ">
                    <div className="conent-aria text-center pt-5">
                        <h1 className="text-primary banner_text pt-5 font-bold text-5xl mt-4 uppercase">
                            Reviews
                        </h1>
                        <p className="mt-4 w-[90%] mx-auto text-[#919191]">
                            {" "}
                            Our Active & Expert Developer. Those who are always ready for the
                            project
                        </p>
                    </div>
                    <div className="  custom_container mx-auto py-10 px-5 ">
                        <Swiper
                            slidesPerView={3}
                            spaceBetween={25}
                            slidesPerGroup={3}
                            loop={true}
                            centerSlide={"true"}
                            fade={"true"}
                            grabCursor={"true"}
                            pagination={{
                                dynamicBullets: true,
                            }}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            modules={[Pagination, Autoplay]}
                            className="mySwiper"
                            breakpoints={{
                                0: {
                                    slidesPerView: 1,
                                },
                                520: {
                                    slidesPerView: 2,
                                },
                                950: {
                                    slidesPerView: 3,
                                },
                            }}
                        >
                            {reviews?.map((review) => (
                                <SwiperSlide>
                                    <div className="carousel-item w-full mx-auto justify-center mb-8">
                                        <div className=' bg-white w-96 p-3 h-96 rounded-lg  items-center justify-center text-center mx-3 shadow-2xl'>
                                            <div className='avatar mx-auto'>
                                                <div className='w-24 mask mask-decagon'>
                                                    <img src={review?.img ? review?.img : 'https://freesvg.org/img/abstract-user-flat-1.png'} alt="" />
                                                </div>
                                            </div>
                                            <h1 className='text-2xl font-bold'>{review?.name}</h1>
                                            <h1 className='w-52 mx-auto'>{review?.review}</h1>
                                            {/* <div className='rating'>
                                                {
                                                    gettingRatings?.map((rating, index) => <p key={index}>{rating}</p>)
                                                }
                                            </div> */}
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Reviews;